export default __webpack_public_path__ + "media/titles/title_2_locale_nb-55aa2315.png";